import React from 'react';
import {
    Switch,
    Route,
    Redirect,
    RouteProps,
    withRouter,
} from 'react-router';
import { hasAccessTokenInLocalStorage, createReturnUrl, getReturnUrl } from '_helpers';
import { Location } from 'history';
import { IRootState } from '../redux/store/configureStore';
import { connect } from 'react-redux';
import UnAuthorizedHandler from './UnAuthorizedHandler';
import AuthorizedHandler from './AuthorizedHandler';

const Routes = ({ auth }: Props) => {
    if (hasAccessTokenInLocalStorage()) {
        const returnUrl = getReturnUrl();

        return (
            <Switch>
                {returnUrl && <Redirect to={returnUrl} />}
                <Redirect path="/login" to="/" />
                <Redirect exact path="/" to="/participation-requests" />

                {auth && auth.profile && !auth.profile.registrationCompleted && !auth.profile.sovietMember && (
                    <Redirect exact path="/" to="/registration-completion" />
                )}
                {auth && auth.profile && !auth.profile.registrationCompleted && !auth.profile.sovietMember && (
                    <Redirect exact path="/participation-requests" to="/registration-completion" />
                )}
                {auth && auth.profile && auth.profile.registrationCompleted && !auth.profile.sovietMember && (
                    <Redirect exact path="/registration-completion" to="/" />
                )}

                {auth && auth.profile && !auth.profile.nokMember && <Redirect exact path="/participation-requests" to={auth.profile.sovietMember ? '/soviet-protocols' : '/exam-in-progress'} />}
                {auth && auth.profile && !auth.profile.nokMember && <Redirect exact path="/expert-qualifications" to={auth.profile.sovietMember ? '/soviet-protocols' : '/exam-in-progress'} />}
                {auth && auth.profile && !auth.profile.nokMember && <Redirect exact path="/expert-certificate" to={auth.profile.sovietMember ? '/soviet-protocols' : '/exam-in-progress'} />}
                {auth && auth.profile && !auth.profile.nokMember && <Redirect exact path="/exam-timetables" to={auth.profile.sovietMember ? '/soviet-protocols' : '/exam-in-progress'} />}
                {auth && auth.profile && !auth.profile.nokMember && <Redirect exact path="/connected-ec" to={auth.profile.sovietMember ? '/soviet-protocols' : '/exam-in-progress'} />}
                {auth && auth.profile && !auth.profile.nokMember && <Redirect exact path="/exam-list" to={auth.profile.sovietMember ? '/soviet-protocols' : '/exam-in-progress'} />}
                {auth && auth.profile && !auth.profile.nokMember && auth.profile.sovietMember && <Redirect exact path="/exam-in-progress" to="/soviet-protocols" />}
                {auth && auth.profile && !auth.profile.sovietMember && <Redirect exact path="/soviet-protocols" to="/exam-in-progress" />}

                <Route
                  path="/"
                  render={({ location }) => (
                        <AuthorizedHandler location={location} />
                    )}
                />
            </Switch>
        );
    }

    createReturnUrl();

    return (
        <Switch>
            <Route
              path="/"
              render={({ location }) => (
                    <UnAuthorizedHandler location={location} />
                )}
            />
            <Redirect to="/login" />
        </Switch>
    );
};
const mapState = (state: IRootState) => ({
    auth: state.auth.auth,
});

export default (withRouter(connect(mapState)(Routes))) as React.ComponentType<Props | RouteProps>;

type connectedProps = ReturnType<typeof mapState>;

interface RouteOwnProps {
    location: Location;
}

type Props = connectedProps & RouteOwnProps;
